import { useTranslate } from '@tolgee/react';
import Copy from './Copy';
import styled from '@emotion/styled';
import { memo } from 'react';
import dayjs from 'dayjs';

function MercadoLogistics({
  logistics,
  isDetail,
}: {
  logistics: Conversation.Trade.MercadoLogistics;
  isDetail?: boolean;
}) {
  const { trackingNumber, shippingCarrier, packageNumber, trackingInfo } = logistics;

  const { t } = useTranslate();

  return (
    <Container isDetail={String(isDetail)}>
      <dl>
        <dt>{t('物流公司')}</dt>
        <dd>
          {{
            fulfillment: 'FULL',
            self_service: 'ENVIOS FLEX',
          }[shippingCarrier] || '-'}
        </dd>
      </dl>
      <dl>
        <dt>{t('物流单号')}</dt>
        <dd>
          {trackingNumber}
          <Copy
            text={trackingNumber}
            successMessage={t('trade.copyLogisticsSucceed')}
            failedMessage={t('trade.copyLogisticsFailed')}
          />
        </dd>
      </dl>
      {trackingInfo.map(({ updateTime, description }) => {
        const label = {
          shipped_date: t('trade.出货日期'),
          returned_date: t('返回日期'),
          delivered_date: t('交货日期'),
          cancelled_date: t('取消派送日期'),
          ready_to_ship_date: t('准备发货日期'),
        }[description];

        if (!label) {
          return null;
        }

        return (
          <dl>
            <dt>{label}</dt>
            <dd>{Number(updateTime) ? dayjs(Number(updateTime)).format('YYYY/MM/DD') : '-'}</dd>
          </dl>
        );
      })}
      <dl>
        <dt>{t('包裹ID')}</dt>
        <dd>{packageNumber}</dd>
      </dl>
    </Container>
  );
}

const Container = styled.div<{ isDetail: string }>`
  width: ${({ isDetail }) => (isDetail === 'true' ? '100%' : '260px')};
  > dl {
    display: flex;
    flex-direction: ${({ isDetail }) => (isDetail === 'true' ? 'row' : 'column')};
    align-items: flex-start;
    > dt {
      flex: 0 0 auto;
      margin-right: 8px;
      font-size: 12px;
      font-weight: 400;
      color: #84868c;
    }
    > dd {
      flex: 1 0 0;
      display: flex;
      align-items: center;
      margin-bottom: 0;
      font-size: 12px;
    }
  }
`;

export default memo(MercadoLogistics);
